import { 
  LayoutDashboard, 
  FileText, 
  FolderTree, 
  Users, 
  Mail, 
  Settings,
  PlusCircle,
  MessageSquare
} from 'lucide-react';

export const menuItems = [
  { 
    icon: LayoutDashboard, 
    text: 'Dashboard', 
    path: '/admin',
    exact: true
  },
  { 
    icon: FolderTree, 
    text: 'Categories', 
    path: '/admin/categories'
  },
  { 
    icon: Users, 
    text: 'Users', 
    path: '/admin/users'
  },
  { 
    icon: MessageSquare, 
    text: 'Messages', 
    path: '/admin/contact'
  },
  { 
    icon: Settings, 
    text: 'Settings', 
    path: '/admin/settings3'
  },
   { 
    icon: FileText, 
    text: 'Posts', 
    path: '/admin/posts',
    subItems: [
      { text: 'All Posts', path: '/admin/posts' },
      { text: 'Create New', path: '/admin/posts/create', icon: PlusCircle }
    ]
  }, 
];